<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useQuizterStore } from '../../stores/quizterStore';
import Questions from '../../components/Questions.vue';
import Card from '../../components/Card.vue';
import QuestionProgressIndicator from '../../components/QuestionProgressIndicator.vue';
import NextButton from '../../components/NextButton.vue';
import useLocale from '../../../composables/use-locale';
import { useDisplay } from 'vuetify';

const quizterStore = useQuizterStore();
const {
  currentQuestion,
  currentQuestionIndex,
  numberOfQuestions,
  isLoading,
  answersReceivedForCurrentQuestion,
  questionCountdown,
  gameOptions,
} = storeToRefs(quizterStore);

const { t } = useLocale();
const { smAndUp } = useDisplay();
</script>

<template>
  <div class="d-flex flex-column align-center ga-6">
    <div class="d-flex gc-4">
      <QuestionProgressIndicator
        v-if="smAndUp"
        class="my-2"
        :totalQuestions="numberOfQuestions!"
        :completedQuestions="currentQuestionIndex + 1"
      ></QuestionProgressIndicator>
      <Card v-if="currentQuestion" :content-max-width="800">
        <Transition name="fade" mode="out-in">
          <Questions
            :currentQuestion="currentQuestion"
            :key="`question-${currentQuestionIndex}`"
            :currentQuestionIndex="currentQuestionIndex"
            :numberOfQuestions="numberOfQuestions"
            :showTimer="gameOptions.useTimer"
            :host="true"
          />
        </Transition>
        <div v-if="answersReceivedForCurrentQuestion" class="chalkboard-font text-h6 mt-2 d-flex justify-center">
          {{ t('players_answered', answersReceivedForCurrentQuestion) }}
        </div>
      </Card>
    </div>
    <NextButton
      v-if="questionCountdown === 0"
      :loading="isLoading"
      @click="quizterStore.showCorrectAnswer"
      data-testid="quizter-show-answer-button"
    >
      {{ t('results.button_show_answer') }}
    </NextButton>
  </div>
</template>
